module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('header', {
    staticClass: "navbar"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/pocketlegal_logo.png"),
      "alt": "PocketLegal"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-hand",
    attrs: {
      "id": "username"
    }
  }, [_c('avatar', {
    staticClass: "headerAvatar",
    attrs: {
      "user": _vm.user
    }
  }), _vm._v("\n        " + _vm._s(_vm.user.profile.firstname) + " " + _vm._s(_vm.user.profile.lastname) + "\n        "), _c('span', {
    staticClass: "chevron"
  }), _vm._v(" "), _c('div', {
    staticClass: "usernameMenu"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('i', {
    staticClass: "fa fa-cog",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Edit Profile\n            ")])], 1), _vm._v(" "), _c('li', {
    staticClass: "logout c-hand",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("Logout\n          ")])])])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar-toggle"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bbe273f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 519
// module chunks = 1